<template>
  <div>
    <div class="d-flex justify-content-between p-2">
      <div>
        <el-button type="default" @click="$router.back()">
          <i class="el-icon-back" />
          <span v-t="'general.back'" />
        </el-button>
      </div>
    </div>
    <div v-if="item">
      <div class="h2 text-left">
        {{ item.get('or_id') || '-' }}
      </div>
      <div v-if="item" class="grid-container">
        <OrderCustomerCard
          class="mb-3"
          :customer="user"
          :delivery-address="deliveryAddress"
          :delivery-date="deliveryDate"
        />
        <OrderInformationCard class="mb-3" :information="information" />
        <OrderCartCard class="mb-3" :products="products" :systems="systems" />
      </div>
      <el-card v-if="false">
        <div slot="header" class="text-left font-weight-bold">
          {{ $t('general.actions') }}
        </div>
        -
      </el-card>
    </div>
  </div>
</template>

<script>
import OrderCustomerCard from '../../../admin/detail-order-request/components/OrderCustomerCard';
import OrderInformationCard from '../../../admin/detail-order-request/components/OrderInformationCard';
import OrderCartCard from '../../../admin/detail-order-request/components/OrderCartCard';
import User from '../../../../api/dto/User';
import DeliveryAddress from '../../../../api/dto/DeliveryAddress';
export default {
  name: 'AccountRequestDetailView',
  components: { OrderCartCard, OrderInformationCard, OrderCustomerCard },
  props: {},
  async mounted() {
    let query = new this.$parse.Query('CartRequest');
    query.include('deliveryAddress');
    query.include('user');
    this.item = await query.get(this.$route.params.id);
  },
  destroyed() {},
  data() {
    return {
      item: null,
    };
  },
  computed: {
    user() {
      return new User(this.item.get('user'));
    },
    deliveryAddress() {
      if (!this.item.get('deliveryAddress')) return null;
      return new DeliveryAddress(this.item.get('deliveryAddress'));
    },
    deliveryDate() {
      if (!this.item.get('deliveryDate')) {
        return null;
      }
      return this.item.get('deliveryDate').toLocaleDateString();
    },
    information() {
      return {
        contactAtLocation: this.item.get('contactAtLocation'),
        lkw: this.item.get('lkw'),
        project: this.item.get('project'),
      };
    },
    products() {
      return this.item.get('products') || [];
    },
    systems() {
      return this.item.get('systems') || [];
    },
  },
  methods: {},
};
</script>

<style scoped></style>
